export default __webpack_public_path__ + "static/media/Hair_10_M_C4.01c95c6d.svg";